import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

import { showLoading, hideLoading } from '../../../../store/app';
import WebAPIClient, {
  errorResponseToastr,
} from '../../../../api/_energytracer';

export default function CountyLookup() {
  const dispatch = useDispatch();

  const [requestData, setRequestData] = useState([]);
  const [states, setStates] = useState([]);
  const [counties, setCounties] = useState([]);

  const [selectedState, setSelectedState] = useState('');
  const [selectedCounty, setSelectedCounty] = useState('');

  const fetchData = useCallback(async () => {
    dispatch(showLoading());
    try {
      const data = await new WebAPIClient().GET(
        '/veregy_benchmarking/query_counties'
      );
      setRequestData(data);
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      dispatch(hideLoading());
    }
    dispatch(hideLoading());
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let local_states = Object.keys(requestData);
    setStates(local_states);
    if (local_states.length > 0) {
      setSelectedState(local_states[0]);
    } else {
      setSelectedState('');
    }
  }, [requestData]);

  useEffect(() => {
    if (states.length > 0 && selectedState !== '') {
      let local_counties = Object.keys(requestData[selectedState]);
      setCounties(local_counties);
      if (local_counties.length > 0) {
        setSelectedCounty(local_counties[0]);
      } else {
        setSelectedCounty('');
      }
    } else {
      setCounties([]);
      setSelectedCounty('');
    }
  }, [requestData, states, selectedState]);

  return (
    <div>
      <h3>County Lookup</h3>
      <form>
        <List disablePadding>
          <ListItem disableGutters>
            <FormControl id='state' variant='standard' fullWidth>
              <InputLabel id='state-label'>State</InputLabel>
              <Select
                labelId='state-label'
                name='state'
                onChange={(e) => {
                  setSelectedState(e.target.value);
                }}
                value={selectedState}
                MenuProps={{
                  MenuListProps: { disablePadding: true },
                  slotProps: {
                    paper: { sx: { minWidth: 'unset !important' } },
                  },
                }}
                sx={{
                  backgroundColor: 'unset',
                  '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                  },
                }}
              >
                <MenuItem value=''></MenuItem>
                {states.map((state) => {
                  return (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </ListItem>
        </List>
        {counties.length > 0 && selectedState !== '' && (
          <List disablePadding>
            <ListItem disableGutters>
              <FormControl id='county' variant='standard' fullWidth>
                <InputLabel id='county-label'>County</InputLabel>
                <Select
                  labelId='county-label'
                  name='county'
                  onChange={(e) => {
                    setSelectedCounty(e.target.value);
                  }}
                  value={selectedCounty}
                  MenuProps={{
                    MenuListProps: { disablePadding: true },
                    slotProps: {
                      paper: { sx: { minWidth: 'unset !important' } },
                    },
                  }}
                  sx={{
                    backgroundColor: 'unset',
                    '& .MuiSelect-select': {
                      display: 'flex',
                      alignItems: 'center',
                    },
                  }}
                >
                  <MenuItem value=''></MenuItem>
                  {counties.map((county) => {
                    return (
                      <MenuItem key={county} value={county}>
                        {county}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </ListItem>
          </List>
        )}
        {selectedCounty !== '' && (
          <h4>Climate Zone: {requestData[selectedState][selectedCounty]}</h4>
        )}
      </form>
    </div>
  );
}
